<template>
    <div class="p-2">
        <form @submit.prevent="submitForm"> 
            <div class="row">
                <div class="border-right col-sm-12 col-md-5 mb-2 d-flex align-items-center">
                    <div class="rounded-pill bg-white shadow-sm pl-3 p-2 border-faded mr-3 d-flex flex-row align-items-center justify-content-start flex-shrink-0">
                        <img class="profile-icon img-thumbnail img-responsive rounded-circle" :src="staff.icon != '' ? getIcon(staff.icon) : require('@/assets/image/icon/profile.png')"/>
                        <div class="m-3">
                            <h5 class="text-primary mb-1">
                                {{staff.name}}
                                <small class="mt-2 text-dark mb-0 fw-300">
                                    <span class="d-block">
                                        <i class="fal fa-phone-alt mr-2 "></i>
                                        +{{staff.mobile}}
                                    </span>
                                    <i class="fal fa-store mr-2"></i>
                                    {{outlet.text}}
                                </small>
                            </h5>
                        </div>
                    </div>
                </div>
                <div class="col-sm-12 col-md-7 pl-5 p-3">
                    <h4 class="fw-700 mb-3">{{$t('header.slot')}}: {{convertTimestampToDateDay(this.selectedDate)}}</h4>
                    <div class="form-group">
                        <label class="form-label">{{$t('table.header.type')}}</label>
                        <div class="input-group-prepend w-100">
                            <label class="input-group-text bg-transparent border-top-right-radius-0 border-bottom-right-radius-0 border-right-0">
                                <i class="fas fa-tags"></i>
                            </label>
                            <multiselect v-model="selectedBreakType" label="DfBreakTypeTitle" track-by="DfBreakTypeID" :options="breakType" :searchable="false" :show-labels="false" openDirection="below" @select="selectBreakType">
                                <template slot="option" slot-scope="{ option }">{{option.DfBreakTypeTitle}}</template>
                            </multiselect>
                        </div>
                    </div>
                    <div class="form-group">
                        <label class="form-label">{{$t('outlet_setting.roster.recursive')}}</label>
                        <div class="input-group-prepend w-100">
                            <label class="input-group-text bg-transparent border-top-right-radius-0 border-bottom-right-radius-0 border-right-0">
                                <i class="fas fa-repeat"></i>
                            </label>
                            <multiselect v-model="selectedRecursive" label="text" track-by="id" :options="recursive" :searchable="false" :show-labels="false" openDirection="below" @select="selectRecursive">
                                <template slot="option" slot-scope="{ option }">{{option.text}}</template>
                            </multiselect>
                        </div>
                    </div>
                    <div v-if="selectedRecursive.id != 'no'">
                        <div class="row">
                            <div class="col-sm-12 col-md-4 mb-2">
                                <div class="form-group">
                                    <label class="form-label">{{$t('outlet_setting.roster.recursive_to')}}</label>
                                    <div class="custom-control custom-switch">
                                        <input type="checkbox" class="custom-control-input" id="recursiveTo" v-model="recursiveTo" @change="updateRecursiveMsg">
                                        <label class="custom-control-label" for="recursiveTo">{{$t('outlet_setting.roster.end_of_year')}}</label>
                                    </div>
                                </div>
                            </div>
                            <div v-if="!recursiveTo" class="col-sm-12 col-md-8">
                                <div class="form-group">
                                    <label class="form-label">{{$t('label.select', {'item': $t('table.header.date')})}}</label>
                                    <date-range-picker class="w-100"
                                        ref="picker"
                                        v-model="selectedRecursiveDate"
                                        :opens="'left'"
                                        :locale-data="{firstDay: 1, format: 'dd/mm/yyyy'}"
                                        :autoApply="true"
                                        :showDropdowns="true" 
                                        :always-show-calendars="true"
                                        :single-date-picker="true"
                                        :ranges="false"
                                        @showCustomRange="showCustomRangeCalendars=true"
                                        @update="selectDate">
                                    </date-range-picker>
                                </div>
                            </div>
                        </div>
                        <p class="mt-2 text-primary fw-300">{{recursive_msg}}</p>
                    </div>
                </div>
            </div>
            <div class="border-top pt-3 mt-3">
                <button type="button" class="btn border-0 btn-secondary btn-padding waves-effect waves-themed mr-3" @click="returnRoster">{{$t('button_link.cancel')}}</button>
                <button type="submit" class="btn border-0 btn-primary btn-padding waves-effect waves-themed">{{$t('button_link.save')}}</button>
            </div>
        </form>
    </div>
</template>
<script>
import moment from 'moment'
import DateRangePicker from 'vue2-daterange-picker'
import {handleSessionExpired} from './../../../../assets/js/dashboard/dashboard'
export default {
    name:"staffRosterForm",
    props:{
        breakType: Array
    },
    components:{
        DateRangePicker
    },
    data(){
        let startDate = moment().startOf('day');
        let endDate = moment().endOf('day');
        return{
            outlet: {},
            staff: {},
            selectedBreakType: {},
            selectedDate: "", selectedDay: "",
            selectedRecursive: {},
            recursiveTo: 1,
            selectedRecursiveDate: {startDate, endDate},
            recursive_msg: "",
        }
    },
    computed:{
        recursive(){
            return[
                {id: "no", text: this.$i18n.t('label.no', {'item': this.$i18n.t('outlet_setting.roster.recursive')})},
                {id: "daily", text: this.$i18n.t('outlet_setting.roster.daily')},
                {id: "weekly", text: this.$i18n.t('outlet_setting.roster.weekly')},
            ]
        }
    },
    methods:{
        closeModal(isError){
            if(!isError){
                this.returnRoster()
            }
            this.$parent.$parent.isModalShow = false
        },
        getIcon(img){
            return img
        },
        convertTimestampToDateDay(ts){
            return moment(ts*1000).format('ddd, DD/MM/YYYY')
        },
        setStaffForm(obj, outlet, date){
            this.outlet = outlet
            this.staff = obj
            this.selectedDate = parseInt(date)
            this.selectedDay = moment(parseInt(date)*1000).format('dddd')
            this.updateRecursiveMsg()
        },
        selectBreakType(item){
            this.selectedBreakType = item
        },
        selectRecursive(item){
            this.selectedRecursive = item
            this.recursiveTo = item.id == 'daily' ? 0 : 1;
            this.updateRecursiveMsg()
        },
        selectDate(date){
            this.selectedRecursiveDate = date
            this.updateRecursiveMsg()
        },
        updateRecursiveMsg(){
            var expired = !this.recursiveTo ? moment(this.selectedRecursiveDate.startDate).format('DD/MM/YYYY') :  moment(this.selectedRecursiveDate.startDate).endOf('year').format('DD/MM/YYYY')
            var day = this.selectedRecursive.id == 'weekly' ? this.selectedDay : this.$i18n.t('outlet_setting.roster.day')
            this.recursive_msg = this.$i18n.t('outlet_setting.roster.recursive_msg', {'day': day, 'expired': expired})
        },
        resetForm(){
            this.recursiveTo = 1
            this.selectedBreakType = this.breakType[0]
            this.selectedRecursive = this.recursive[0]
        },
        returnRoster(){
            this.resetForm()
            this.$emit('returnRoster')
        },
        setFormData(){
            var breakDates = []
            var date = moment(this.selectedDate*1000)
            breakDates.push(date.format('YYYY/MM/DD'))

            if(this.selectedRecursive.id != 'no'){
                var day = date.day()
                var endDate = !this.recursiveTo ? moment(this.selectedRecursiveDate.startDate) : moment(date).endOf('year')

                if(this.selectedRecursive.id == 'weekly'){
                    var current = date.clone();
                    while (current.day(7 + day).isBefore(endDate)) {
                        breakDates.push(current.clone().format('YYYY/MM/DD'));
                    }
                }else{
                    var curr = date.clone().add(1, 'days');
                    while (curr < endDate) {
                        breakDates.push(curr.clone().format('YYYY/MM/DD'));
                        curr = moment(curr).add(1, 'days');
                    }
                }
            }
            var data = {
                identifier: this.$uuid.v1(),
                staffID: this.staff.staffID,
                DfBreakTypeID: this.selectedBreakType.DfBreakTypeID,
                breakDates: breakDates
            }
            return data
        },
        submitForm(){
            var data = this.setFormData()
            let $vm = this;
            
            $vm.$axios({
                method: 'post', 
                url: $vm.$api.STAFF_ROSTER,
                baseURL: $vm.$axios.defaults.baseURL, 
                headers: {token: $vm.$session.get('token')},
                data: data,
            })
            .then(function(response) {
               if(response.status == 200){
                    var message = $vm.$i18n.t('outlet_setting.roster.off_day') + $vm.$i18n.t('message.success.success', {'action': $vm.$i18n.t('message.success.action.add')})
                    $vm.$parent.$parent.setModal($vm, false, true, message);
                }        
            })
            .catch((err) => {
                var error = err.response.data.error;
                if(error == $vm.$api.INVALID_TOKEN){
                    handleSessionExpired();   
                }
            })
        }
    },
    mounted(){
        let $vm = this
        $vm.selectedBreakType = $vm.breakType[0]
        $vm.selectedRecursive = $vm.recursive[0]
    },
}
</script>
<style>
.profile-icon{
    width: 6em;
    height: 6em;
}
</style>